/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Mode_AttemptInputs */

const zh_print_mode_attempt = /** @type {(inputs: Print_Mode_AttemptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作答记录`)
};

const en_print_mode_attempt = /** @type {(inputs: Print_Mode_AttemptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attempt Record`)
};

const es_print_mode_attempt = /** @type {(inputs: Print_Mode_AttemptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de intento`)
};

/**
* | output |
* | --- |
* | "Attempt Record" |
*
* @param {Print_Mode_AttemptInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const print_mode_attempt = /** @type {((inputs?: Print_Mode_AttemptInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Mode_AttemptInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_mode_attempt(inputs)
	if (locale === "en") return en_print_mode_attempt(inputs)
	return es_print_mode_attempt(inputs)
});